import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICustomerSetting, ICustomerSettingsState } from '../../types/store';
import {
  IGetAllCustomerSettingsResponse,
  IUpdateMetavalueResponse,
} from '../../types/api/response/customersettingsresponse';
import { IUpdateMetavalueRequest } from '../../types/api/request/customersettingsrequest.d';

const initialState: ICustomerSettingsState = {
  content: [],
  page: {
    size: 20,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const customerSettingSlice = createSlice({
  name: 'customerSettingSlice',
  initialState,
  reducers: {
    setCustomerSettings: (state, action) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    updateMetavalue: (state, action: PayloadAction<IUpdateMetavalueResponse>) => {
      const index = state.content.findIndex(
        (setting: ICustomerSetting) => setting.metakey === action.payload.metakey,
      );
      if (index !== -1) {
        state.content[index].metavalue = action.payload.metavalue;
      }
    },
    addCustomerSetting: (state, action: PayloadAction<ICustomerSetting>) => {
      state.content.push(action.payload);
    },
  },
});

export const { setCustomerSettings, updateMetavalue, addCustomerSetting } =
  customerSettingSlice.actions;

export default customerSettingSlice.reducer;
